// Added by sephora-jsx-loader.js
var React = require('react');
// Added by sephora-jsx-loader.js
var wrapComponentRenderModule = require('utils/framework/wrapComponentRender'); // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var createClass = require('create-react-class')

// Added by sephora-jsx-loader.js
var wrapComponentRender = wrapComponentRenderModule.wrapComponentRender; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
var EmptyClass;// Added by sephora-jsx-loader.js
Sephora.Util.InflatorComps.Comps['Empty'] = { 
    getReactClass: function Empty() { // eslint-disable-line max-len, func-name-matching
        return EmptyClass;
    }
};
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
let Empty = function () {
    return null;
};

Empty.prototype.getInitialState = Empty;

Empty.prototype.render = function () {
    return null;
};


// Added by sephora-jsx-loader.js
Sephora.Util.InflatorComps.Comps['Empty'].class = Empty; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
Empty.prototype.class = Empty.prototype.displayName = 'Empty';
// Added by sephora-jsx-loader.js
Empty.prototype.render = wrapComponentRender(Empty);
// Added by sephora-jsx-loader.js
// .jsx// Added by sephora-jsx-loader.js

Empty.prototype.getInitialState = function() {
    Empty.apply(this, this.props.constructorArgs);
    return this.state;
};
Empty.prototype.originClass = Empty;
EmptyClass = createClass(Empty.prototype);
EmptyClass.prototype.classRef = EmptyClass;
Object.assign(EmptyClass, Empty);
module.exports = EmptyClass;
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
// Added by sephora-jsx-loader.js

